import React from "react";

import { IOptionValues } from "../../../models/catalogue.interfaces";
import { IImageURL, isoImageURL } from "../../../models/nominals";
import { VariantHeroBlock } from "../../../models/streamfield-blocks";
import { useAppSelector } from "../../reducers";
import { defaults } from "../defaults";
import { upgradedRootProductSelector } from "../selectors";

interface IOwnProps {
    defaultBackgroundImage: IImageURL | null;
    defaultMobileBackgroundImage: IImageURL | null;
    defaultImageTitle: string;
    variantHeroInfo?: VariantHeroBlock[];
}

interface HeroImage {
    desktop: IImageURL | null;
    mobile: IImageURL | null;
    alt: string;
}

export const PDPHero = (props: IOwnProps): React.ReactNode => {
    const selectedRootProduct = useAppSelector((rootState) => {
        const state = rootState.configurator || defaults;
        return upgradedRootProductSelector(state);
    });

    const selectedValues = useAppSelector((rootState) => {
        const state = rootState.configurator || defaults;
        return state.ui.optionValues;
    });

    const getHeroImage = (): HeroImage => {
        const defaultImage: HeroImage = {
            desktop: props.defaultBackgroundImage,
            mobile: props.defaultMobileBackgroundImage,
            alt: props.defaultImageTitle,
        };
        if (!props.variantHeroInfo || !selectedValues) {
            return defaultImage;
        }
        const sortedHeroImages = props.variantHeroInfo
            .map((hero) => {
                let score = 0;
                if (hero.product === selectedRootProduct?.id) {
                    score += 2;
                }
                if (hero.product === null) {
                    score += 1;
                }

                if (
                    hero.value ===
                    selectedValues[hero.attribute as keyof IOptionValues]
                ) {
                    score += 1;
                }

                return {
                    score: score,
                    hero: hero,
                };
            })
            .sort((a, b) => {
                if (a.score === b.score) {
                    return 0;
                }
                return a.score > b.score ? -1 : 1;
            });
        const imageToUse =
            sortedHeroImages.length > 0 ? sortedHeroImages[0].hero : null;
        if (!imageToUse) {
            return defaultImage;
        }
        return {
            desktop: imageToUse.image.url,
            mobile: imageToUse.mobile_image?.url || null,
            alt: imageToUse.image.title,
        };
    };

    const heroImg = getHeroImage();
    return (
        <picture className="pdp-hero__image">
            {heroImg.mobile && (
                <source
                    srcSet={isoImageURL.unwrap(heroImg.mobile)}
                    media="(max-width: 768px)"
                ></source>
            )}
            {heroImg.desktop && (
                <img
                    src={isoImageURL.unwrap(heroImg.desktop)}
                    alt={heroImg.alt}
                />
            )}
        </picture>
    );
};
